module.exports = __webpack_public_path__ + "img/LisaHarp.c97e0a5e.jpg";